import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { recentNews } from "./announcements";
import Nav from "../nav";
import axios from "axios";
import './announcement.css'

export default function AnnouncementDetails() {
  const { id } = useParams();

  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchSingle = async () => {
      try {
        const { data } = await axios.get(`/api/v1/announcements/${id}`);
        setData(data.announcement);
      } catch (error) {
        console.error(error);
      }
    };

    fetchSingle();
  }, [id]);

  if (!data) return <h2>Announcement Not Found</h2>;

  return (
    <>
      <Nav />

      <div style={{ padding: "0px 40px 0px 40px" }}>
        <div className="row">
          {/* IMAGE */}
          <div className="announcement-details-banner">
            {data.image ? (
              <img
                src={data.image}
                alt="announcement"
                className="announcement-details-banner-img"
              />
            ) : (
              <div className="announcement-details-no-image">No Image</div>
            )}
          </div>

          {/* CONTENT */}
          <div className="">
            {/* SUBJECT */}
            <div>
              <h2
                className="hd"
                style={{
                  fontSize: "34px",
                  fontWeight: "700",
                  marginBottom: "10px",
                  color: "#ffad63",
                }}
              >
                {data.subject}
              </h2>

              <p
                style={{
                  color: "#8c8c8c",
                  marginBottom: "25px",
                  fontSize: "14px",
                }}
              >
                {new Date(data.createdAt).toLocaleDateString()} | {data.type}
              </p>
            </div>

            {/* MAIN HEADING */}
            {data.mainHeading && (
              <h3
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  marginBottom: "15px",
                  color: "#1f1f1f",
                  lineHeight: "1.5",
                }}
              >
                {data.mainHeading}
              </h3>
            )}

            {/* MAIN PARAGRAPH */}
            {data.mainParagraph && (
              <p
                style={{
                  fontSize: "16px",
                  lineHeight: "1.9",
                  color: "#555",
                  marginBottom: "30px",
                }}
              >
                {data.mainParagraph}
              </p>
            )}

            {/* LIST SECTION */}
            {data.listSection?.heading && (
              <div style={{ marginBottom: "30px" }}>
                <h4
                  style={{
                    fontSize: "22px",
                    fontWeight: "600",
                    marginBottom: "15px",
                  }}
                >
                  {data.listSection.heading}
                </h4>

                <ul
                  style={{
                    paddingLeft: "20px",
                    lineHeight: "2",
                    color: "#555",
                  }}
                >
                  {data.listSection.items?.map((item, index) => (
                    <li
                      key={index}
                      style={{
                        marginBottom: "8px",
                        fontSize: "16px",
                      }}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* SUB SECTION */}
            {data.subSection?.heading && (
              <div style={{ marginBottom: "30px" }}>
                <h4
                  style={{
                    fontSize: "22px",
                    fontWeight: "600",
                    marginBottom: "15px",
                  }}
                >
                  {data.subSection.heading}
                </h4>

                {data.subSection.paragraphs?.map((para, index) => (
                  <p
                    key={index}
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.9",
                      color: "#555",
                      marginBottom: "18px",
                    }}
                  >
                    {para}
                  </p>
                ))}
              </div>
            )}

            {/* PDF BUTTON */}
            {data.attachmentPdf && (
              <button
                onClick={() => window.open(data.attachmentPdf, "_blank")}
                style={{
                  marginTop: "10px",
                  padding: "12px 18px",
                  backgroundColor: "#ffad63",
                  color: "#fff",
                  borderRadius: "6px",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "15px",
                  width: "180px",
                  fontWeight: "500",
                }}
              >
                📄 View PDF
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}